export function getParam(name, url) {
  let src = url || window.location.href
  if (name && src) {
    var r = new RegExp("(\\?|#|&|^)" + name + "=([^&^#]*)(#|&|$)")
    var m = src.match(r)
    return !m ? "" : decodeURIComponent(m[2])
  }
  return ""
}

export function delParam(name, url) {
  if (!(name instanceof Array)) {
    name = [name]
  }

  name.forEach(function(v) {
    url = url.replace(new RegExp("(?:&" + v + "=[^&]*)", "g"), "")
    url = url.replace(new RegExp("(?:\\?" + v + "=[^&]*&?)", "g"), "?")
  })
  return url
}
